import { useAssetLogoManifest } from "~/v2/hooks/useAssetLogoManifest";
import { useAssetLogoTheme } from "~/v2/hooks/useAssetLogoTheme";
import type { AssetIconProps } from "../AssetSearch.types";
import { useAssetIconController } from "./AssetIcon.controller";
import { AssetIconPresentation } from "./AssetIcon.pres";

/**
 * AssetIcon connector — owns external reads and wires the controller to the
 * presenter.
 */
export function AssetIcon({
  name,
  size = "base",
  ...svgProps
}: AssetIconProps) {
  const theme = useAssetLogoTheme();
  const {
    availableSymbols,
    symbolsWithDark,
    isLoading: isManifestLoading,
  } = useAssetLogoManifest();
  const baseUrl =
    typeof window !== "undefined" ? window.env?.ASSET_LOGO_BASE_URL : undefined;

  const {
    visualState,
    initials,
    theme: controllerTheme,
    imageSrc,
    imageAlt,
    preloadSrc,
    onPreloadLoad,
    onPreloadError,
  } = useAssetIconController({
    name,
    theme,
    baseUrl,
    isManifestLoading,
    availableSymbols,
    symbolsWithDark,
  });

  return (
    <AssetIconPresentation
      visualState={visualState}
      initials={initials}
      theme={controllerTheme}
      size={size}
      imageSrc={imageSrc}
      imageAlt={imageAlt}
      preloadSrc={preloadSrc}
      onPreloadLoad={onPreloadLoad}
      onPreloadError={onPreloadError}
      {...svgProps}
    />
  );
}
